import { Formik, Form } from 'formik'
import { useEffect, useState } from 'react'
import Column from '@components/column'
import Row from '@components/row'
import Button from '@components/button'
import Fields from '@components/fields'
import { useSelector } from 'react-redux'
import { Category, LabTest } from '@apis'
import { LabTestSchema } from '@validations'
import { styleHalfInputWrapper } from './style'
import { useLocation, useNavigate } from 'react-router-dom'
const initial = {
  categoryId: '',
  sampleTypeIds: [],
  name: '',
  shortcode: '',
}
const LabTestForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const { data: labTestCategories } = useSelector(
    (state: any) => state.labTestCategories,
  )
  const { data: sampleTypes } = useSelector((state: any) => state.sampleTypes)
  const [initialValues, setInitialValues] = useState(initial)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values: any, { resetForm }) => {
    setLoading(true)
    if (state?.id) {
      await LabTest.update({
        data: values,
        id: state?.id,
      })
        .then(() => {
          navigate('.')
        })
        .catch(() => {})
    } else {
      await LabTest.create({
        data: values,
      })
        .then((resp) => {
          console.log(resp)
          resetForm()
        })
        .catch(() => {})
    }
    setLoading(false)
  }

  const fetchCategories = async () => {
    await Category.list({
      state: 'labTestCategories',
      params: {
        type: 'LabTest',
      },
    })
  }

  const fetchSampleTypes = async () => {
    await Category.list({
      state: 'sampleTypes',
      params: {
        type: 'SampleType',
      },
    })
  }

  useEffect(() => {
    if (!labTestCategories?.length) {
      fetchCategories()
    }
    if (!sampleTypes?.length) {
      fetchSampleTypes()
    }
  }, [])

  useEffect(() => {
    if (!!state?.id) {
      setInitialValues({
        name: state?.name,
        categoryId: state?.category?.id,
        shortcode: state?.shortcode,
        sampleTypeIds: state?.sampleTypes?.map((sample) => sample.id),
      })
    } else {
      setInitialValues(initial)
    }
  }, [state?.id])

  return (
    <Column bg="white" styleColumn="border-radius:12px;padding:15px;">
      <Formik
        initialValues={initialValues}
        onSubmit={submitHandler}
        enableReinitialize
        validationSchema={LabTestSchema.validationSchema}
      >
        {({ handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Column rowGap={20}>
                <Row justifyContent="space-between">
                  <Fields.Input
                    name="name"
                    placeholder="Enter Lab Test Name"
                    label="Lab Test Name"
                    styleWrapper={styleHalfInputWrapper}
                  />
                  <Fields.DropDown
                    name="categoryId"
                    options={labTestCategories}
                    placeholder="Select Category"
                    label="Category"
                    titleAsKey="name"
                    valueAsKey="id"
                    styleWrapper={styleHalfInputWrapper}
                  />
                </Row>
                <Row justifyContent="space-between">
                  <Fields.DropDown
                    name="sampleTypeIds"
                    options={sampleTypes}
                    placeholder="Select Sample Type"
                    label="Sample Types"
                    titleAsKey="name"
                    valueAsKey="id"
                    styleWrapper={styleHalfInputWrapper}
                    isMultiple
                  />
                  <Fields.Input
                    name="shortcode"
                    placeholder="Enter Shortcode"
                    label="Shortcode"
                    styleWrapper={styleHalfInputWrapper}
                  />
                </Row>
                <Column alignItems="flex-end">
                  <Button
                    type="submit"
                    title="Save"
                    height={40}
                    loading={loading}
                  />
                </Column>
              </Column>
            </Form>
          )
        }}
      </Formik>
    </Column>
  )
}

export default LabTestForm
